"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasurementPopup = void 0;
const image_button_1 = require("../../components/button/image.button");
const icons_1 = require("../../components/icon/icons");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const measurement_popup_style_1 = require("./measurement.popup.style");
const core_shared_1 = require("@ikegps/core-shared");
const services_1 = require("../../services");
(0, theme_1.addStyles)(measurement_popup_style_1.Style);
exports.MeasurementPopup = {
    view(cfg) {
        const isPaused = cfg.measurementState.isPaused;
        return (0, mithril_1.m)('div', { className: measurement_popup_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: measurement_popup_style_1.CSS.header }, [
                (0, mithril_1.m)('div', { className: measurement_popup_style_1.CSS.title }, (0, i18n_1.Translate)(i18n_1.T.TOPO_TOOL_MEASURE)),
                (0, mithril_1.m)('div', { className: measurement_popup_style_1.CSS.headerActions }, [
                    image_button_1.ImageButton.view(isPaused ? icons_1.MaterialIcon.PLAY_CIRCLE : icons_1.MaterialIcon.PAUSE_CIRCLE, {
                        onclick: () => {
                            cfg.measurementState.setPaused(!isPaused);
                            if (cfg.onPauseChange)
                                cfg.onPauseChange();
                        },
                        title: isPaused ? i18n_1.T.MEASUREMENT_RESUME_TOOLTIP : i18n_1.T.MEASUREMENT_PAUSE_TOOLTIP,
                    }),
                    image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
                        onclick: cfg.onClose,
                        title: i18n_1.T.CLOSE,
                    }),
                ]),
            ]),
            (0, mithril_1.m)('div', { className: measurement_popup_style_1.CSS.content }, [
                cfg.measurementState.points.length >= 2
                    ? (0, mithril_1.m)('div', [
                        (0, mithril_1.m)('div', { className: measurement_popup_style_1.CSS.measurementRow }, [
                            (0, mithril_1.m)('div', { className: measurement_popup_style_1.CSS.measurementLabel }, (0, i18n_1.Translate)(i18n_1.T.MEASUREMENT_RULING_SPAN)),
                            (0, mithril_1.m)('div', { className: measurement_popup_style_1.CSS.measurementValue }, core_shared_1.IkeUnit.display(cfg.measurementState.rulingSpan, services_1.Services.UserSettings.units)),
                        ]),
                        (0, mithril_1.m)('div', { className: measurement_popup_style_1.CSS.measurementRow }, [
                            (0, mithril_1.m)('div', { className: measurement_popup_style_1.CSS.measurementLabel }, (0, i18n_1.Translate)(i18n_1.T.MEASUREMENT_TOTAL_DISTANCE)),
                            (0, mithril_1.m)('div', { className: measurement_popup_style_1.CSS.measurementValue }, core_shared_1.IkeUnit.display(cfg.measurementState.totalDistance, services_1.Services.UserSettings.units)),
                        ]),
                    ])
                    : (0, mithril_1.m)('div', { className: measurement_popup_style_1.CSS.emptyState }, (0, i18n_1.Translate)(i18n_1.T.MEASUREMENT_EMPTY_STATE)),
            ]),
        ]);
    },
};
//# sourceMappingURL=measurement.popup.js.map